import React from 'react'
import styled from 'styled-components'
import { featureBackgroundColor } from '../../styles/colors'

const FeatureWrapper = styled.div`
    display: flex;
    flex-direction: column;
    flex-basis: 50%;
    background-color: ${featureBackgroundColor};
    padding: 20px;
    margin-bottom: 40px;

    > h6 {
        margin-bottom: 10px;
    }
    > p:last-child {
        margin: 0px;
    }
`

type FeatureProps = {
    title: string
    descriptions: string[]
}

export const Feature = ({ title, descriptions }: FeatureProps) => (
    <FeatureWrapper>
        <h6>{title}</h6>
        {descriptions.map((description, index) => (
            <p key={index}>{description}</p>
        ))}
    </FeatureWrapper>
)
